import { envSchema } from './env/env.schema';
import { z } from 'zod';

type Schema = z.infer<typeof envSchema>;

export type SegmentsVersion = '1' | '2';

export enum DeleteMemberAction {
  SCRUB_DATA = 'SCRUB_DATA',
  MEMBERSHIP_DELETE = 'MEMBERSHIP_DELETE',
  BOTH = 'BOTH',
}

export type Config = {
  env: string;
  release?: string;
  stage: Schema['REACT_APP_OC_STAGE'];
  brandName: string;
  experienceUrl?: string;
  isLiteVersion: boolean;
  integrationGuideUrl: string;

  sentry?: string;
  activityLogPollingInterval: number;

  api: {
    host: string;
    docUrl: string;
    commandKey: string;
    commandUrl: string;
    commandWsUrl?: string;
  };

  google: {
    mapsApiKey?: string;
    analyticsId?: string;
  };

  communicationPreference: {
    enabled: boolean;
    optInConfigurable: {
      sms: boolean;
      email: boolean;
      push: boolean;
    };
  };

  retailerConnect: {
    enabled: boolean;
    networkManagementEnabled: boolean;
    addExistingUserEnabled: boolean;
  };

  storedValue: {
    enabled: boolean;
  };

  features: {
    walletSteeringEnabled: boolean;
    scanDataTabEnabled: boolean;
    promptAtPumpEnabled: boolean;
    mpaSimulatorEnabled: boolean;
    messagingCenterEnabled: boolean;
    externalBannersEnabled: boolean;
    promocodesOffersEnabled: boolean;
    mobileTransactionsEnabled: boolean;
    deleteMemberEnabled: boolean;
    deleteMemberAction: DeleteMemberAction;
  };
};
